// removed by extract-text-webpack-plugin
module.exports = {"note":"Note__note___2Wm6a","noteContainer":"Note__noteContainer___3Vql3","noteText":"Note__noteText___qEfqe","noteFooter":"Note__noteFooter___3EFRR"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/adminNotes/Note/Note.scss
// module id = 1230
// module chunks = 0